// src/store/persistence.ts
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import organizationReducer from './slices/organizationSlice';
import branchReducer from './slices/branchSlice';
import categoryReducer from './slices/categorySlice';
import menuItemReducer from './slices/menuItemSlice';
import uiReducer from './slices/uiSlice';
import dietaryReducer from './slices/dietarySlice';
import currencyReducer from './slices/currencySlice';
import announcementReducer from './slices/announcementSlice';

// Configure what to persist
const persistConfig = {
	key: 'root',
	storage,
	whitelist: ['auth', 'ui'], // Only persist auth and UI preferences
	blacklist: ['organization', 'branch', 'category', 'menuItem', 'dietary', 'currency', 'announcements'], // Don't persist data that should be fresh
};

const uiPersistConfig = {
	key: 'ui',
	storage,
	whitelist: ['theme', 'language', 'menuItemsViewMode', 'categoriesViewMode'], // Only persist UI preferences
	blacklist: ['modals', 'notifications', 'loadingStates'], // Don't persist temporary UI state
};

const authPersistConfig = {
	key: 'auth',
	storage,
	whitelist: ['user', 'isAuthenticated'], // Only persist auth state
	blacklist: ['isLoading', 'error'], // Don't persist loading/error states
};

const rootReducer = combineReducers({
	auth: persistReducer(authPersistConfig, authReducer),
	organization: organizationReducer,
	branch: branchReducer,
	category: categoryReducer,
	menuItem: menuItemReducer,
	dietary: dietaryReducer,
	currency: currencyReducer,
	announcements: announcementReducer,
	ui: persistReducer(uiPersistConfig, uiReducer),
});

export const persistedReducer = persistReducer(persistConfig, rootReducer);

// Export types for the persisted store
export type PersistedRootState = ReturnType<typeof rootReducer>;